import { ComponentView, View } from "binder"
import { ExpanderViewModel } from "./expander-viewModel"
import { getAsBoolean } from "../utilities";

export class ExpanderView extends ComponentView<ExpanderViewModel>{
    GetViewUniqueId(): string {
        return "V-19AE352A-8F93-49A2-B77A-22B8337DC365"
    }
    loadHtml(): string {
        let element = require('./expander.html').default;
        let style = require('./expander.less');
        return element;
    }
    constructor() {
       super();
    }
    private getSiblingExpanders():HTMLElement[]{
        let parentElement = this.firstlevelElement.parentElement;
        let result : HTMLElement[] = [];
        if(parentElement.classList && parentElement.classList.contains('accordion')==true){
            let siblings = parentElement.children;
            for(let i=0;i<siblings.length;i++){
                try{
                    let s = siblings.item(i);
                    if(s!=this.firstlevelElement && s instanceof HTMLElement){
                        let viewModel = (<any>s).binderRelatedView.dataContext;
                        if(viewModel instanceof ExpanderViewModel ){
                            result.push(<HTMLElement>s);
                        }
                    }
                }catch{}
            }
        }else if(parentElement && parentElement.parentElement && parentElement.parentElement.classList && parentElement.parentElement.classList.contains('accordion')==true){
            let grandParentElement = parentElement.parentElement;
            let parentSiblings = grandParentElement.children;
            for(let i=0;i<parentSiblings.length;i++){
                let uncle = parentSiblings.item(i);
                let children = uncle.children;
                for(let j=0;j<children.length;j++){
                    try{
                        let s = children.item(j);
                        if(s!=this.firstlevelElement && s instanceof HTMLElement){
                            let viewModel = (<any>s).binderRelatedView.dataContext;
                            if(viewModel instanceof ExpanderViewModel ){
                                result.push(<HTMLElement>s);
                            }
                        }
                    }catch{}
                }
            }
        }

        return result;
    }
    public set expanded(v: boolean) { 
        this._expanded = getAsBoolean(v);
        if(this.expanded){
            
            let parentElement = this.firstlevelElement.parentElement;
            let siblings = this.getSiblingExpanders();
            siblings.forEach(x=>{
                try{
                    let viewModel = (<any>x).binderRelatedView.dataContext;
                    if(viewModel instanceof ExpanderViewModel){
                        viewModel.expanded = false;
                    }
                }catch{

                }
            })
            if(parentElement.classList.contains('accordion')){
                let siblings = parentElement.children;
                for(let i=0;i<siblings.length;i++){
                    try{
                        let s = siblings.item(i);
                        if(s!=this.firstlevelElement){
                            let viewModel = (<any>s).binderRelatedView.dataContext;
                            if(viewModel instanceof ExpanderViewModel){
                                viewModel.expanded = false;
                            }
                        }
                    }catch{}
                } 
            }
        }
    } public get expanded(): boolean { return this._expanded;} private _expanded: boolean;

    public onRenderCompleted() {
        
    }

    append(...nodes: (string | Node)[]): void {
        let header = this.firstlevelElement.querySelector('.V-19AE352A-8F93-49A2-B77A-22B8337DC365.headerPlaceHolder');
        let body = this.firstlevelElement.querySelector('.V-19AE352A-8F93-49A2-B77A-22B8337DC365-bodyPlaceHolder');
        nodes.forEach(node=>{
            if(node instanceof HTMLElement && node.classList.contains('expander-header')){
                header.append(node)
            }else if(node instanceof HTMLElement && node.classList.contains('expander-body')){
                body.append(node)
            }
        });
    }

    toggle(){
        this.dataContext.toggle();
    }
}
